__turbopack_context__.v({
  "completeButton": "P1dksa_completeButton",
  "completeButtonWrapper": "P1dksa_completeButtonWrapper",
  "dateBoxWrapper": "P1dksa_dateBoxWrapper",
  "datePickerWrapper": "P1dksa_datePickerWrapper",
  "dateText": "P1dksa_dateText",
  "dateTextWrapper": "P1dksa_dateTextWrapper",
  "infoText": "P1dksa_infoText",
  "roundedBorder": "P1dksa_roundedBorder",
  "textWrapper": "P1dksa_textWrapper",
  "vippsButtonWrapper": "P1dksa_vippsButtonWrapper",
});
